import REST from '../rest';

const ENDPOINT = 'api/v1/companies';

export const load = (params) => REST.get(ENDPOINT, '', params);

export const get = (id, props) => REST.get(ENDPOINT, id, props);
